export const userMessages = {
  'campaign:chat_expert': ({ location, channel, design, result }) => {
    return `Hey! I’m interested in launching a campaign and would love some help before finalizing the details. 

Here’s what I have so far:

📍 Location: ${location}
📦 Campaign Type: ${channel}
🎨 Design Option: ${design}
💰 Estimated Budget: $ ${result}`
  },
  'campaign:create': ({ location, channel, design, result }) => {
    return `Hey! Can you help me review my campaign for better results?

📍 Location: ${location}
📦 Campaign Type: ${channel}
🎨 Design Option: ${design}
💰 Estimated Budget: $ ${result}`
  },
}
